module.exports = __webpack_public_path__ + "img/img4.d13e3e79.svg";